// extracted by mini-css-extract-plugin
module.exports = {"root":"FreeText_root__Ikw8W","cover":"FreeText_cover__EpWU3"};